.link {
  display: inline-flex;
  align-items: center;
  width: var(--button-width, auto);
  text-decoration: none;
  cursor: pointer;

  &.--primary {
    color: var(--cxsLinkColor);

    &:hover {
      color: var(--cxsLink_Hover_Color);
      text-decoration: underline;
    }
  }

  &.--secondary {
    color: var(--cxsShell_MenuTextColor);

    &:hover {
      text-decoration: underline;
    }
  }

  &.--inherit {
    color: inherit;
  }

  &.--standard {
    color: var(--cxsLinkColor);
    text-decoration: underline;

    &:hover {
      color: var(--cxsLink_Hover_Color);
    }

    &:active {
      color: var(--cxsLink_Active_Color);
    }

    &:visited {
      color: var(--cxsLinkColor);
    }
  }

  &:focus {
    outline: 2px solid var(--cxsContent_FocusColor);
    outline-offset: var(--cxs-spacer-xxs);
  }

  &:focus:not(:focus-visible) {
    outline: 0;
  }

  &:hover {
    .icon {
      filter: invert(25%) sepia(58%) saturate(5609%) hue-rotate(183deg) brightness(98%) contrast(106%);
    }
  }
}
